import { Injectable } from "@angular/core";
import { AuthenticationService } from "../authentication.service";
import {
  Http,
  Headers,
  RequestOptions,
  Response,
  URLSearchParams
} from "@angular/http";


@Injectable()
export class RestItemService {
  constructor(private auth: AuthenticationService, private http: Http) { }



  Get_ItemByItemcode(FilterBarcode: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ItemByItemcode",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getItemId(CustFilter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ItemId",
        CustFilter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GenBarcode(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_GenBarcode",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveItem(FilterBarcode: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_Item",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  UpdateItem(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Update_Item",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetSellingPriceRoomLevelByLocation(FilterBarcode: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_SellingPriceRoomLevel",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  CheckIsincredient(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/CheckIsincredient",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getCategory(FilteData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_Categorys",
        FilteData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getPrinter(FilteData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_Printer",
        FilteData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ItemTaxDetailsByItemId(FilteData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ItemTaxDetailsByItemId",
        FilteData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  save_ImageDetails(FilteData: any) {
    if (FilteData.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Save_ImageDetails",
          FilteData,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
    else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Update_ImageDetails",
          FilteData,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  Get_ImageDetailsByItemId(FilteData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ImageDetailsByItemIdForEdit",
        FilteData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GenModifiercode(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_GenModifiercode",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ModifierList(FilterBarcode: any){
    return this.http
    .post(
      this.auth.baseUrl + "/services/api/rest/v1/Get_ModifierList",
      FilterBarcode,
      this.auth.getHeader()
    )
    .map(res => {
      return res.json();
    })
  }

  // UploadDescriptionImages(FilterBarcode: any){
  //   return this.http
  //   .post(
  //     this.auth.baseUrl + "/services/api/rest/v1/UploadDescriptionImages",
  //     FilterBarcode,
  //     this.auth.getHeader()
  //   )
  //   .map(res => {
  //     return res.json();
  //   })
  // }

  UploadDescriptionImages(){
    return this.auth.baseUrl + "/services/api/rest/v2/UploadDescriptionImages"
  }
}





// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/services/restaurant/rest-item.service.ts